'use client';

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '../AdminLayout';
import { ArrowLeftIcon, BuildingOffice2Icon } from '@heroicons/react/24/outline';
import TenantsTable from './TenantsTable';

export default function TenantsManagementPage() {
  return (
    <AdminLayout>
      {/* Page Header */}
      <div className="mb-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <BuildingOffice2Icon className="h-8 w-8 text-gray-700 mr-3" />
            <h1 className="text-2xl font-bold text-gray-900">Tenant Management</h1>
          </div>
          <Link
            to="/admin-tools"
            className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            <ArrowLeftIcon className="h-5 w-5 text-gray-500 mr-2" />
            Back to Admin Tools
          </Link>
        </div>
        <p className="mt-2 text-sm text-gray-600">Manage tenant subscriptions and settings.</p>
      </div>

      {/* Main content */}
            {/* Main content */}
      <TenantsTable />
    </AdminLayout>
  );
}
